import React from 'react';

import "./style.css"

function Index(props) {
    return (
        <>
            <a className="logo" href="javascript:;">QQ</a>
            <div className="side"></div>

            <div className="top">
                <a href="javascript:;"><img className="logo2" src={require("./image/logo2.png")}/><span
                    className="good-number">QQ靓号</span></a>
                <a href="javascript:;">简体中文<img src={require('./image/down.png')}/></a>
                <a href="javascript:;">意见反馈</a>
            </div>

            <div className="main-wrap">

                <form className="myform" action="" method="POST">

                    <div className="welcome">欢迎注册QQ</div>
                    <div className="slogan">每一天，乐在沟通。</div>

                    <div className="row">
                        <input className="txt" type="text" placeholder="昵称"/>
                    </div>

                    <div className="row">
                        <input className="txt" type="text" placeholder="密码"/>
                    </div>

                    <div className="row">
                        <input className="txt area" type="text" value="+86"/>
                        <input className="txt mobile" type="text" placeholder="手机号码"/>
                    </div>

                    <div className="info">可通过该手机号找回密码</div>

                    <div className="row">
                        <button type="submit" onClick={(e)=>{e.preventDefault()}}>立即注册</button>
                    </div>

                    <div className="info">

                        <label>
                            <input type="checkbox" checked/>
                            <span>我已阅读并同意相关服务条款和隐私政策</span>
                        </label>

                    </div>
                </form>

                <div className="footer">Copyright &copy; 1998-2020 Tencent All Rights Reserved</div>
            </div>
        </>
    );
}

export default Index;